import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../../../atoms/Typography';
import PresenceSummary from './PresenceSummary';

const TitleBlock = ({ title, description, presence }) => {
  const isChannelTitle = typeof title === 'string' && title.startsWith('#');
  const channelName = isChannelTitle ? title.slice(1) : title;
  return (
    <div className="channel-header__title">
      <Typography variant="h1" component="h1" className="channel-header__name-badge">
        {isChannelTitle && (
          <span className="channel-header__name-badge-hash">#</span>
        )}
        <span className="channel-header__name">{channelName}</span>
      </Typography>
      {presence ? <PresenceSummary presence={presence} /> : null}
      {description ? (
        <Typography variant="subtitle2" component="p" className="channel-header__description">
          {description}
        </Typography>
      ) : null}
    </div>
  );
};

TitleBlock.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  presence: PropTypes.shape({
    isAvailable: PropTypes.bool,
    onlineCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

TitleBlock.defaultProps = {
  description: undefined,
  presence: undefined,
};

export default TitleBlock;


